import { Stack } from "@mui/material";
import { memo } from "react";
import ScheduleItem from "../Schedule/ScheduleItem";
import { IScheduleListProps } from "./models";
import LinkAccessScheduleItem from "../Schedule/LinkAccessScheduleItem";

const ScheduleList: React.FC<IScheduleListProps> = ({ schedules, checkInRule, isHistoric }) => {
  return (
    <Stack gap={1} mt={1}>
      {!schedules.isLinkAccess && schedules.data.map((s) => (
        <ScheduleItem data={s} checkInRule={checkInRule} key={s.identifier} />
      ))}
      {schedules.isLinkAccess && schedules.data.map((s) => (
        <LinkAccessScheduleItem data={s} key={s.identifier} isHistoric={isHistoric} />
      ))}
    </Stack>
  );
};

export default memo(ScheduleList);
